import React, { useMemo } from 'react';
import { emojiIndex } from 'emoji-mart';

import PopperList from '../components/PopperList';
import EmojiListItem from './EmojiListItem';
import { emojiPopperStyles } from './styles';
import { EmojiListProps } from './types';

function EmojiList(props: EmojiListProps) {
  const { onClick, searchString, onClose, popperProps } = props;

  const items = useMemo(() => {
    if (searchString) {
      return emojiIndex.search(searchString) ?? [];
    }
    return [];
  }, [searchString]);

  return (
    <PopperList
      className={emojiPopperStyles}
      items={items}
      popperProps={popperProps}
      renderItem={(item, index, isSelected) => (
        <EmojiListItem
          key={index}
          index={index}
          isSelected={isSelected}
          item={item}
          onClick={onClick}
        />
      )}
      onClose={onClose}
      onItemClick={onClick}
    />
  );
}

export default EmojiList;
